var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowsExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.216195 5.83924C0.504396 5.52656 0.971661 5.52656 1.25986 5.83924L7.52186 12.6332C7.81006 12.9458 7.81006 13.4528 7.52186 13.7655C7.23366 14.0782 6.76639 14.0782 6.47819 13.7655L0.216195 6.97156C-0.072005 6.65888 -0.0720052 6.15192 0.216195 5.83924Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7839 5.83922C14.0721 6.1519 14.0721 6.65885 13.7839 6.97154L7.52186 13.7655C7.23366 14.0782 6.76639 14.0782 6.47819 13.7655C6.18999 13.4528 6.18998 12.9458 6.47819 12.6331L12.7402 5.83922C13.0284 5.52653 13.4957 5.52653 13.7839 5.83922Z",
    fill: "#919EAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.21615 0.234632C0.504351 -0.0780495 0.971616 -0.0780495 1.25982 0.234632L7.52181 7.02856C7.81002 7.34124 7.81002 7.8482 7.52181 8.16088C7.23361 8.47356 6.76635 8.47356 6.47815 8.16088L0.21615 1.36695C-0.07205 1.05427 -0.0720502 0.547314 0.21615 0.234632Z",
    fill: "#919EAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7838 0.234511C14.072 0.547193 14.072 1.05415 13.7838 1.36683L7.52181 8.16088C7.23361 8.47356 6.76635 8.47356 6.47815 8.16088C6.18995 7.8482 6.18994 7.34112 6.47814 7.02844L12.7401 0.234511C13.0283 -0.0781704 13.4956 -0.0781705 13.7838 0.234511Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsExpand);
export default __webpack_public_path__ + "static/media/icon-arrows-expand.a1118c7d8617f8e6981cbd9aa54e3165.svg";
export { ForwardRef as ReactComponent };